// extracted by mini-css-extract-plugin
export default {"jobsContainer":"jobsContainer---mVCNB"};